<template>
  <div>
    <b-container class="logo">
    <div class="bv-example-row container">
      <div class="row">
          <div class="col"></div>
          <div class="col"></div>
          <div class="col"><br>
              <svg id="OMNYA_Integration_Platform" data-name="OMNYA Integration Platform" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.15 31.07">
                  
                  <g>
                      <path class="cls-111" d="M18.81,11.21c0-4.77-3.57-8.77-9.2-8.77S.44,6.47.44,11.21A8.74,8.74,0,0,0,9.57,20C15.34,20,18.81,15.83,18.81,11.21Zm-15.59,0a6.41,6.41,0,1,1,12.81,0,6.41,6.41,0,1,1-12.81,0Z" transform="translate(-0.44 -2.44)" />
                      <polygon class="cls-111" points="35.15 17.12 37.78 17.12 37.78 0.38 35.48 0.38 29.8 8.84 24.08 0.38 21.54 0.38 21.54 17.12 23.96 17.12 23.96 4.55 24.01 4.55 29.09 12.07 30.02 12.07 35.1 4.55 35.15 4.55 35.15 17.12" />
                      <polygon class="cls-111" points="54.65 13.15 43.9 0.38 41.74 0.38 41.74 17.12 44.02 17.12 44.02 4.29 54.75 17.12 56.93 17.12 56.93 0.38 54.65 0.38 54.65 13.15" />
                      <polygon class="cls-111" points="65.25 17.12 67.91 17.12 67.91 8.5 74.01 0.38 71 0.38 66.64 6.23 62.3 0.38 59.16 0.38 65.25 8.5 65.25 17.12" />
                      <path class="cls-111" d="M86.85,19.57h2.71L82.11,2.82H80.24L73.08,19.57h2.3l2.16-5.06H84.6Zm-8.48-7L80.24,8a14.09,14.09,0,0,0,.7-2,15.12,15.12,0,0,0,.76,2l2,4.55Z" transform="translate(-0.44 -2.44)" />
                      <rect class="cls-111" y="21.7" width="1.09" height="6.96" />
                      <path class="cls-111" d="M5.63,26.24A1.85,1.85,0,0,0,4.09,27v-.61H3.16V31.1h1V27.8A1.36,1.36,0,0,1,5.31,27c.6,0,.91.4.91,1V31.1h1V28.05C7.22,26.64,6.34,26.24,5.63,26.24Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M10.52,30.43c-.3,0-.64-.16-.64-.72V27.14h1.46v-.79H9.88V25.26L8.16,27v.18h.73v2.59a1.41,1.41,0,0,0,1.55,1.49,2.46,2.46,0,0,0,1.14-.31v-.8a1.61,1.61,0,0,1-1,.32Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M14.45,26.18a2.5,2.5,0,0,0,.16,5,3.56,3.56,0,0,0,1.81-.44L16.29,30a2.44,2.44,0,0,1-1.39.41h-.29a1.52,1.52,0,0,1-1.42-1.52h3.38a2.18,2.18,0,0,0,0-.25C16.58,27,15.76,26.18,14.45,26.18Zm-1.23,1.95A1.25,1.25,0,0,1,14.44,27a1.13,1.13,0,0,1,1.15,1.17Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M20.48,30.63c-.35-.05-.77-.11-1-.16s-.55-.19-.54-.4v0c0-.28.4-.38.83-.42a1.61,1.61,0,0,0,1.69-1.56,1.22,1.22,0,0,0-.42-.92h.89v-.8H19.59a1.76,1.76,0,0,0-2,1.66,1.48,1.48,0,0,0,1.09,1.45c-.39.09-.73.27-.77.65a.22.22,0,0,0,0,.08.64.64,0,0,0,.5.59,1.41,1.41,0,0,0-1.24,1.32c0,.88.94,1.41,2.36,1.41S21.9,32.88,22,32v-.07C22,31.27,21.48,30.76,20.48,30.63ZM18.54,28a1,1,0,1,1,1,1A1,1,0,0,1,18.54,28Zm1,4.79c-.86,0-1.42-.3-1.42-.76s.56-.74,1.42-.74S21,31.6,21,32,20.41,32.8,19.54,32.8Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M25.39,26.24a1.54,1.54,0,0,0-1.3,1v-.92h-1V31.1h1V28.89c0-1.18.48-1.67,1-1.74h.15a1,1,0,0,1,.74.28l.27-.87a1.22,1.22,0,0,0-.84-.31Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M30.45,30.5c-.12,0-.19-.14-.19-.32V27.81a1.49,1.49,0,0,0-1.69-1.56,2.37,2.37,0,0,0-1.58.59v.85a1.85,1.85,0,0,1,1.42-.64c.56,0,.85.33.85.92v.2a7.71,7.71,0,0,0-1.15.28c-.63.21-1.39.61-1.37,1.51V30A1.16,1.16,0,0,0,28,31.19a1.8,1.8,0,0,0,1.32-.55.64.64,0,0,0,.73.55,1.78,1.78,0,0,0,.83-.2v-.58a.65.65,0,0,1-.32.1Zm-1.19-.42a1.07,1.07,0,0,1-.82.39.63.63,0,0,1-.71-.64c0-.62.62-.92,1.53-1.07Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M33.52,30.43c-.3,0-.64-.16-.64-.72V27.14h1.46v-.79H32.88V25.26L31.16,27v.18h.73v2.59a1.41,1.41,0,0,0,1.55,1.49,2.46,2.46,0,0,0,1.14-.31v-.8a1.61,1.61,0,0,1-1,.32Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M36.14,24.23a.59.59,0,1,0,.59.59A.59.59,0,0,0,36.14,24.23Z" transform="translate(-0.44 -2.44)" />
                      <rect class="cls-111" x="35.21" y="23.91" width="1" height="4.75" />
                      <path class="cls-111" d="M40.47,26.23A2.5,2.5,0,1,0,43,28.73,2.47,2.47,0,0,0,40.47,26.23Zm0,4.2A1.71,1.71,0,1,1,42,28.73,1.57,1.57,0,0,1,40.47,30.43Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M46.69,26.24a1.85,1.85,0,0,0-1.54.72v-.61h-.92V31.1h1V27.8A1.36,1.36,0,0,1,46.36,27c.61,0,.92.4.92,1V31.1h1V28.05C48.27,26.64,47.4,26.24,46.69,26.24Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M54.92,24.14H52.68v7h1.1V28.19h1c1.61,0,2.42-.88,2.42-2A2,2,0,0,0,54.92,24.14Zm-.09,3.26h-1V24.93h1.09a1.15,1.15,0,0,1,1.22,1.22A1.18,1.18,0,0,1,54.83,27.4Z" transform="translate(-0.44 -2.44)" />
                      <rect class="cls-111" x="58.02" y="21.7" width="0.99" height="6.96" />
                      <path class="cls-111" d="M64.41,30.5a.29.29,0,0,1-.2-.32V27.81a1.48,1.48,0,0,0-1.68-1.56,2.37,2.37,0,0,0-1.58.59v.85a1.85,1.85,0,0,1,1.42-.64c.56,0,.85.33.85.92v.2a8.15,8.15,0,0,0-1.16.28c-.62.21-1.38.61-1.36,1.51V30a1.16,1.16,0,0,0,1.24,1.17,1.8,1.8,0,0,0,1.32-.55.64.64,0,0,0,.72.55,1.82,1.82,0,0,0,.84-.2v-.58a.65.65,0,0,1-.32.1Zm-1.19-.42a1.07,1.07,0,0,1-.82.39.63.63,0,0,1-.71-.64c0-.62.62-.92,1.53-1.07Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M67.47,30.43c-.29,0-.63-.16-.63-.72V27.14H68.3v-.79H66.84V25.26L65.12,27v.18h.73v2.59a1.41,1.41,0,0,0,1.54,1.49,2.47,2.47,0,0,0,1.15-.31v-.8a1.62,1.62,0,0,1-1,.32Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M70.21,24.47a1.94,1.94,0,0,0-.59,1.72v.16H69v.79h.65v4h1v-4h1.1v-.79h-1.1V26c0-.72.33-1,.85-1a1,1,0,0,1,.56.17v-.88a1.46,1.46,0,0,0-.66-.15A1.67,1.67,0,0,0,70.21,24.47Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M74.77,26.23a2.5,2.5,0,1,0,2.56,2.5A2.47,2.47,0,0,0,74.77,26.23Zm0,4.2a1.71,1.71,0,1,1,1.53-1.7A1.57,1.57,0,0,1,74.77,30.43Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M80.79,26.24a1.53,1.53,0,0,0-1.3,1v-.92h-1V31.1h1V28.89c0-1.18.47-1.67,1-1.74h.15a1,1,0,0,1,.74.28l.27-.87a1.22,1.22,0,0,0-.84-.31Z" transform="translate(-0.44 -2.44)" />
                      <path class="cls-111" d="M88.06,26.23a1.77,1.77,0,0,0-1.58.87,1.41,1.41,0,0,0-1.37-.87,1.75,1.75,0,0,0-1.49.73v-.61h-.92V31.1h1V27.79A1.31,1.31,0,0,1,84.79,27c.6,0,.86.4.86,1V31.1h1V28c0-.09,0-.17,0-.25a1.29,1.29,0,0,1,1.1-.77c.6,0,.87.4.87,1V31.1h1V28C89.59,26.63,88.77,26.23,88.06,26.23Z" transform="translate(-0.44 -2.44)" />
                  </g>
              </svg>
          </div>
          <div class="col"></div>
          <div class="col"></div>
      </div>
    </div>  

  </b-container>
  <br>
  <b-container class="bv-example-row">
    <b-row>
        <b-col></b-col>
        <b-col></b-col>
          <b-col>
            <br>
            <b-form-group
              id="fieldset-login"
              :invalid-feedback="invalidFeedback"
              :state="state"

            >
              <div class="form-group">
                <label for="email">{{lang.Login.label_Login}}</label>
                <input @keyup.enter="login" v-model="credential.login" class="form-control" type="email" id="login" name="login">
              </div>
              <div class="form-group">
                <label for="password">{{lang.Login.label_Password}}</label>
                <input @keyup.enter="login" v-model="credential.password" class="form-control" type="password" id="password" name="password">
              </div>
            </b-form-group>

            <div class="form-group">
                <b-button v-on:click="login" size="sm" class="btn btn-secondary" :variant="variant" >{{lang.Login.button_Login}}</b-button>
            </div>

          </b-col>
        <b-col></b-col>
        <b-col></b-col>
    </b-row>
  </b-container>
  
  </div>




</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
          credential: {
              login:'',
              password:''
          },
          isSuccess: true
      }
    },
    props:{
      lang: Object
    },
    computed:{
      ...mapGetters([
        'isPlugin',
       
      ]),
      state() {
        return true;
      },
      invalidFeedback() {
        if (this.isSuccess) {
          //return lang.Login.infotext_1;
        }
        return 'Please enter something.'
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      }
    },
    methods: {
      login() {

        let _vue = this;



        const credential = {
          login: this.credential.login.trim().toLowerCase(),
          password: this.credential.password.trim()
        }

        let payload = this.$store.dispatch('login', credential)
        .then((result)=>{

          console.log(result)
          if (result.status == "OK"){


            localStorage.setItem('token', result.data[0].Token);

            localStorage.setItem('user', _vue.credential.login.toLowerCase());
            localStorage.setItem('role', result.data[0].Role);
            localStorage.setItem('userId', result.data[0].userId);

            _vue.$store.dispatch("getGlobalSettings");
            _vue.$store.dispatch("getSettings");

            _vue.$store.dispatch('loginConfirm');


            let obj = {
              login: _vue.credential.login.toLowerCase(),
              role: result.data[0].Role,
              userId: result.data[0].userId
            }

            _vue.$store.dispatch('setCurrentUser', obj);

            // if (this.isPlugin){
            //   _vue.$router.push({path: '/PartManager/PartTable'});
            // }else{
               _vue.$router.push({path: '/Dashboard/DashboardWidgets'});
            // }
            

          }else{
            _vue.state = false;
            console.log("Login problem")

            const obj = {
              text: result.message,
              time: 10,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          }




        })
      }
    },
    created: function () {

      let _vue = this;
      
      this.$store.dispatch('whoAmI')
        .then((result)=>{

          console.log(result)
          if (result.status == "OK"){


            localStorage.setItem('token', result.data[0].Token);

            localStorage.setItem('user', _vue.credential.login.toLowerCase());
            localStorage.setItem('role', result.data[0].Role);
            localStorage.setItem('userId', result.data[0].userId);

            _vue.$store.dispatch("getSettings");

            _vue.$store.dispatch('loginConfirm');


            let obj = {
              login: _vue.credential.login.toLowerCase(),
              role: result.data[0].Role,
              userId: result.data[0].userId
            }

            _vue.$store.dispatch('setCurrentUser', obj);

            // if (this.isPlugin){
            //   _vue.$router.push({path: '/PartManager/PartTable'});
            // }else{
               _vue.$router.push({path: '/Dashboard/DashboardWidgets'});
            // }
            

          }
        })
    }
  }
</script>
<style lang="scss">

  .logo{
    .cls-111 {
        fill: #50a9c1;
      }
  }
  .form{
    width: 300px;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/Login.vue